import { UserAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

function AdminRoutes({ children }) {
  const adminId = 'ENj1jE1gioNALVIoOC0qhgsUDBI3';
  const { user } = UserAuth();
  const navigate = useNavigate();

  if (!user) {
    return navigate('/');
  }

  if (user.uid !== adminId) {
    return navigate(`/${user.uid}/dashboard`);
  }

  return children;
}

export default AdminRoutes;
